const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';
import { apiFetch } from './interceptor';

export const locationApi = {
  /**
   * Log a user action with location data
   * @param {Object} data - The location data
   * @param {number} data.latitude - The latitude coordinate
   * @param {number} data.longitude - The longitude coordinate
   * @param {string} data.type - The type of action (login, bet, withdrawal, etc.)
   * @param {Object} data.deviceInfo - Information about the user's device
   * @returns {Promise} - The API response
   */
  logAction: async (data) => {
    const latitude = data.latitude || 0;
    const longitude = data.longitude || 0;
    const type = data.type || '';
    const deviceInfo = data.deviceInfo || {};

    try {
      const response = await apiFetch(`${BASE_URL}/locations/log-action`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ latitude, longitude, type, deviceInfo }),
      });
      
      return await response.json();
    } catch (error) {
      console.error('Location logging error:', error);
      throw error;
    }
  },
}; 